/**
 * PartnerConfirmationYesNo – Partner permission (Berechtigung) only.
 * Used in: StudentDialog.js, StudentsGrid.js.
 * Do not use for logout – use DialogBoxYesNo in App.js instead.
 */
import React, { useEffect } from "react";
import BlockIcon from "@mui/icons-material/Block";
import "./PartnerConfirmationYesNo.css";

function PartnerConfirmationYesNo({ title, text, content, onClose }) {
  const handleKeyPress = (event) => {
    if (event.key === "Escape") {
      onClose(false);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [onClose]);

  const handleYesClick = () => onClose(true);
  const handleNoClick = () => onClose(false);

  return (
    <div className="partner-confirmation-container">
      <div className="partner-confirmation-box">
        <h2 className="partner-confirmation-title">{title}</h2>
        <div className="partner-confirmation-inner">
          <div className="partner-confirmation-body">
            {content ? (
              <div className="partner-confirmation-text">{content}</div>
            ) : (
              <p className="partner-confirmation-text">{text}</p>
            )}
          </div>
          <div className="partner-confirmation-icon">
            <BlockIcon />
          </div>
        </div>
        <div className="partner-confirmation-buttons">
          <button
            type="button"
            className="partner-confirmation-btn partner-confirmation-btn-primary"
            onClick={handleYesClick}
          >
            Ja
          </button>
          <button
            type="button"
            className="partner-confirmation-btn partner-confirmation-btn-secondary"
            onClick={handleNoClick}
          >
            Nein
          </button>
        </div>
      </div>
    </div>
  );
}

export default PartnerConfirmationYesNo;
